/** Plan copy helpers — backend plan keys, localized names/taglines/features. */
export const planName = (t, key, fallback) => {
  if (!key) return fallback || "";
  const label = t(`plans.${key}.name`);
  return label.startsWith("plans.") ? fallback || key : label;
};

export const planTagline = (t, key, fallback) => {
  if (!key) return fallback || "";
  const label = t(`plans.${key}.tagline`);
  return label.startsWith("plans.") ? fallback || "" : label;
};

export const planFeatures = (t, key, fallback = []) => {
  if (!key) return fallback;
  const value = t(`plans.${key}.features`);
  return Array.isArray(value) ? value : fallback;
};

/** Seat limit as text: a number, or the localized "unlimited" label. */
export const seatLimitLabel = (t, maxSeats, unlimited) =>
  unlimited || Number(maxSeats) >= 100000 ? t("common.unlimitedSeats") : String(maxSeats ?? 0);

/** Seat progress: never show a bar for unlimited plans. */
export const seatPercent = (used, maxSeats, unlimited) => {
  if (unlimited || Number(maxSeats) >= 100000 || !maxSeats) return null;
  return Math.min(100, Math.round(((Number(used) || 0) / Number(maxSeats)) * 100));
};
